<template>
	<div class="display-flex flex-row flex-align-center flex-justify-space-between">
		<div class="display-flex flex-column">
			<Row class="flex-align-center">
				<div class="field-text">{{ title }}</div>
				<slot name="indicator" />
			</Row>
			<div v-if="description" class="description-text">{{ description }}</div>
		</div>
		<AppSwitch :disabled="disabled" class="swtch drk sml mr-n1" v-model="localValue" />
	</div>
</template>
<script>
import VModelMixin from '@/mixins/VModelMixin';

export default {
	name: 'SwitchWithIndicatorSlot',
	props: { title: { type: String }, description: { type: String }, disabled: { type: Boolean } },
	mixins: [VModelMixin],
};
</script>

<style lang="scss" scoped>
.field-text {
	font-size: 14px;
	font-weight: normal;
	color: var(--primary-font-color);
}

.description-text {
	font-size: 12px;
	font-weight: normal;
	color: var(--secondary-font-color);
}
</style>
